import { useState, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { useClaimBill } from '../billing/useClaimBill.js';
import { useBusinessNumber } from '../../../../shared/hooks/useBusinessNumber.js';

export function QuantityValidationPage(): ReactNode {
  const { t } = useTranslation();

  const { decimal } = useBusinessNumber();
  const { claimId } = useParams<{ claimId: string }>();
  const { token } = useAuth();
  const { bill, error: claimError } = useClaimBill(`/v1/approval/claim/${claimId}`);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [form, setForm] = useState({ lineId: '', approvedArea: '', executedArea: '', billableArea: '', claimedArea: '' });

  const handleValidate = async () => {
    try {
      const r = await apiRequest<any>('/v1/approval/quantity-validation/', {
        token, method: 'POST',
        body: { claimId, lineId: form.lineId, approvedArea: Number(form.approvedArea), executedArea: Number(form.executedArea), billableArea: Number(form.billableArea), claimedArea: Number(form.claimedArea) },
      });
      setResult(r);
    } catch (e) { setError((e as Error).message); }
  };

  return (
    <div style={{ padding: 24 }}>
      <h1>{t('fa.quantity.title', { bill })}</h1>
      {(error ?? claimError) && <p style={{ color: 'red' }}>{error ?? claimError}</p>}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, maxWidth: 500, marginBottom: 16 }}>
        {[{ k: 'lineId', l: t('fa.quantity.lineId') }, { k: 'approvedArea', l: t('fa.quantity.approvedArea'), t: 'number' }, { k: 'executedArea', l: t('fa.quantity.executedArea'), t: 'number' }, { k: 'billableArea', l: t('fa.quantity.billableArea'), t: 'number' }, { k: 'claimedArea', l: t('fa.quantity.claimedArea'), t: 'number' }].map(f => (
          <label key={f.k}>{f.l}<br /><input type={f.t ?? 'text'} value={(form as any)[f.k]} onChange={e => setForm({ ...form, [f.k]: e.target.value })} style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid var(--color-border-default)' }} /></label>
        ))}
      </div>
      <button onClick={handleValidate} style={{ padding: '8px 24px', background: 'var(--color-text-link)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 6, cursor: 'pointer' }}>{t('fa.quantity.validateBtn')}</button>
      {result && (
        <div style={{ marginTop: 16, padding: 16, border: '1px solid var(--color-border-default)', borderRadius: 8 }}>
          <strong>{t('fa.quantity.result')}</strong> <span style={{ color: result.validationResult === 'PASS' ? 'var(--color-success)' : 'var(--color-danger)' }}>{result.validationResult}</span>
          <span>{t('fa.quantity.variance', { pct: decimal(result.variancePct) })}</span>
          {result.exceptionGenerated && <span style={{ color: 'var(--color-danger)', marginLeft: 8 }}>{t('fa.quantity.exceptionGenerated')}</span>}
        </div>
      )}
    </div>
  );
}
